import { usePublishedData } from "../lib/published-data";
import { useShell } from "../lib/document-route";
import { createFileRoute, notFound, useLocation } from "@tanstack/react-router";
import contentStyles from "../styles/content.css?url";
import { ContentArticle } from "../components/content/content-article";
import { ReadLimit } from "../components/content/read-limit";
import { contentHead } from "../lib/content-head";
import { loadContentItem } from "../server/content";

/** A library item or course lesson (/library/:slug), authorized for this visitor. */
export const Route = createFileRoute("/library/$slug")({
  loader: async ({ params }) => {
    const item = await loadContentItem({ data: { slug: params.slug, section: "library" } });
    if (!item) throw notFound();
    return item;
  },
  head: ({ matches, loaderData, match }) =>
    contentHead(matches, loaderData, match.pathname, contentStyles),
  component: Item,
});

function Item() {
  const shell = useShell();
  const location = useLocation();
  const { data: item } = usePublishedData(Route.useLoaderData(), shell, location.pathname, "page");
  // A member reading faster than one account may gets a calm page instead of the item.
  if ("kind" in item)
    return <ReadLimit page={item} href={location.pathname + location.searchStr} />;
  // Each post starts fresh: a lesson's saved progress never carries over to the next one.
  return (
    <ContentArticle
      key={item.article.id}
      item={item}
      returnPath={location.pathname + location.searchStr}
    />
  );
}
